module.exports = __webpack_public_path__ + "img/optionchain1.f14378ab.jpg";